/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    // @ts-ignore -- Unused import
    NullResult
} from '@msdyn365-commerce/retail-proxy';
// @ts-ignore -- Unused import
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
// @ts-ignore -- Unused import
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

// @ts-ignore
function avaNotifyMeRequestInsertionQuery(result?: boolean): DataServiceQuery {
    const key = result ? { Result: result } : null;
    return new DataServiceQuery(
        'AvaNotifyMeRequestInsertion',
        'AvaNotifyMeRequestInsertionResponseData',
        DataServiceEntities.AvaNotifyMeRequestInsertionResponseDataExtensionClass,
        key
    );
}

export function createAvaNotifyMeRequestInsertionDetailsInput(
    avaNotifyMeRequestInsertionDetails: DataServiceEntities.IAvaNotifyMeRequestInsertionRequestData
): IDataServiceRequest {
    const query = avaNotifyMeRequestInsertionQuery();
    return query.createDataServiceRequestForOperation(
        'AVANotifyMeRequestInsertionDetails',
        true,
        DataServiceEntities.AvaNotifyMeRequestInsertionResponseDataExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IAvaNotifyMeRequestInsertionResponseData' },
        { AVANotifyMeRequestInsertionDetails: avaNotifyMeRequestInsertionDetails }
    );
}

export function avaNotifyMeRequestInsertionDetailsAsync(
    context: IContext,
    avaNotifyMeRequestInsertionDetails: DataServiceEntities.IAvaNotifyMeRequestInsertionRequestData
): AsyncResult<DataServiceEntities.IAvaNotifyMeRequestInsertionResponseData> {
    const request = createAvaNotifyMeRequestInsertionDetailsInput(avaNotifyMeRequestInsertionDetails);
    return callActionOrExecute<DataServiceEntities.IAvaNotifyMeRequestInsertionResponseData>(request, context.callerContext);
}

// @ts-ignore
function aVAProductNotificationEnabledQuery(notificationFLag?: number): DataServiceQuery {
    const key = notificationFLag ? { NotificationFLag: notificationFLag } : null;
    return new DataServiceQuery(
        'AVAProductNotificationEnabled',
        'AVAProductNotificationEnabledEntity',
        DataServiceEntities.AVAProductNotificationEnabledEntityExtensionClass,
        key
    );
}

export function createAVAGetProductNotificationEnabledInput(productId: number, code: string): IDataServiceRequest {
    const query = aVAProductNotificationEnabledQuery();
    return query.createDataServiceRequestForOperation(
        'AVAGetProductNotificationEnabled',
        true,
        '',
        'false',
        { bypassCache: 'get', returnEntity: '' },
        { productId: productId, code: code }
    );
}

export function aVAGetProductNotificationEnabledAsync(context: IContext, productId: number, code: string): AsyncResult<boolean> {
    const request = createAVAGetProductNotificationEnabledInput(productId, code);
    return callActionOrExecute<boolean>(request, context.callerContext);
}
